import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowRight, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useSubscription, isAdminEmail } from "@/lib/subscriptionContext";
import { useAuth } from "@/lib/authContext";

export default function UpsellBanner() {
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  let subscription: any = null;
  try {
    const ctx = useSubscription();
    subscription = ctx.subscription;
  } catch { return null; }

  if (isAdminEmail(user?.email)) return null;
  if (dismissed || !subscription) return null;

  // Free plan: upgrade to Pro
  if (subscription.plan === "free") {
    return (
      <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-accent/10 border border-primary/20 rounded-xl p-4 flex items-center justify-between gap-4 flex-1">
        <div className="flex items-center gap-3">
          <Sparkles className="w-5 h-5 text-primary shrink-0" />
          <div>
          <p className="text-sm font-medium text-foreground">You're on the Free plan — ready for the full experience?</p>
            <p className="text-xs text-muted-foreground">Unlock PDF exports, financial forecasts, and unlimited AI access with Pro.</p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button size="sm" className="gap-1" onClick={() => navigate("/pricing")}>
            See Pro Plan <ArrowRight className="w-3 h-3" />
          </Button>
          <button onClick={() => setDismissed(true)} className="text-muted-foreground hover:text-foreground p-1">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    );
  }

  // Pro: subtle upsell to Studio
  if (subscription.plan === "pro") {
    return (
      <div className="bg-gradient-to-r from-purple-500/5 via-purple-500/5 to-primary/5 border border-purple-500/15 rounded-xl p-3 flex items-center justify-between gap-4 flex-1">
        <div className="flex items-center gap-3">
          <Sparkles className="w-4 h-4 text-purple-500 shrink-0" />
          <p className="text-xs text-muted-foreground">
            <span className="font-medium text-foreground">Go further with Studio</span> — survival scores, lease tracking, team access & white-label exports.
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button size="sm" variant="outline" className="gap-1 text-xs h-7 border-purple-500/20 text-purple-600 hover:bg-purple-500/5" onClick={() => navigate("/pricing")}>
            See Studio <ArrowRight className="w-3 h-3" />
          </Button>
          <button onClick={() => setDismissed(true)} className="text-muted-foreground hover:text-foreground p-1">
            <X className="w-3 h-3" />
          </button>
        </div>
      </div>
    );
  }

  return null;
}
